import React from 'react'
import {Box, Text} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import useTagManager from '../../../hooks/use-tag-manager'
import {Link, Image} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getUrl} from '../../../utils/cloudinary-utils'
import {ENGAGEMENT_BOOK_URL} from '../../../constants'

const DiamondExpertSection = ({product}) => {
    const tagManager = useTagManager()
    const buttonStyles = {
        backgroundColor: 'purple.700',
        borderRadius: '90px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'gray.200',
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: '400',
        letterSpacing: '0.07px',
        height: '52px',
        width: '100%',
        padding: '15px 50px',
        lineHeight: '22px',

        _hover: {
            backgroundColor: 'purple.100'
        }
    }
    const buttonBottomTextStyles = {
        color: 'black',
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: 400,
        marginTop: '10px',
        lineHeight: '22px',
        letterSpacing: '0.07px'
    }
    return (
        <Box>
            <Box
                className="engagement-content-wrapper"
                sx={{
                    h5: {
                        color: 'black',
                        fontSize: '26px',
                        fontFamily: 'heading',
                        fontWeight: 400,
                        letterSpacing: '0.13px',
                        marginBottom: '15px'
                    },
                    p: {
                        color: 'black.100',
                        fontSize: '14px',
                        fontWeight: '300',
                        letterSpacing: '0.07px',
                        lineHeight: '22px'
                    }
                }}
                dangerouslySetInnerHTML={{
                    __html: product?.c_engagementContent
                }}
            />

            <Box marginTop="30px">
                <Link
                    href={ENGAGEMENT_BOOK_URL}
                    target="_blank"
                    {...buttonStyles}
                    marginBottom="15px"
                    onClick={() => {
                        tagManager.ctaInteraction('Book an appointment')
                    }}
                >
                    <Image
                        alt="Arrow"
                        src={getUrl('UIImages/images/engagement-calendar-plus.svg')}
                        width="15px"
                        height="15px"
                        marginRight="10px"
                    />
                    <FormattedMessage
                        defaultMessage="Book an Appointment"
                        id="engagement.book.an.appointment"
                    />
                </Link>

                {(product?.c_engRingsCtaPhoneNoEnable || product?.c_engRingsCtaTextNoEnable) && (
                    <Box display="flex" gap="15px">
                        {product?.c_engRingsCtaPhoneNoEnable && (
                            <Box width="50%">
                                <Link
                                    href={`tel:${product?.c_phoneNoEng}`}
                                    {...buttonStyles}
                                    onClick={() => {
                                        tagManager.ctaInteraction('Call Us')
                                    }}
                                >
                                    <Image
                                        alt="Arrow"
                                        src={getUrl('UIImages/images/engagement-phone.svg')}
                                        width="15px"
                                        height="15px"
                                        marginRight="10px"
                                    />
                                    <FormattedMessage id="call.us" defaultMessage="Call Us" />
                                </Link>
                                <Text {...buttonBottomTextStyles}>{product?.c_phoneNoEng}</Text>
                            </Box>
                        )}

                        {product?.c_engRingsCtaTextNoEnable && (
                            <Box width="50%">
                                <Link
                                    href={`sms:${product?.c_textNoEng}?&body=${product.c_textContent}`}
                                    {...buttonStyles}
                                    onClick={() => {
                                        tagManager.ctaInteraction('Text Us')
                                    }}
                                >
                                    <Image
                                        alt="Arrow"
                                        src={getUrl('UIImages/images/engagement-message.svg')}
                                        width="15px"
                                        height="15px"
                                        marginRight="10px"
                                    />
                                    <FormattedMessage id="text.us" defaultMessage="Text Us" />
                                </Link>
                                <Text
                                    maxWidth="140px"
                                    margin="10px auto 0"
                                    {...buttonBottomTextStyles}
                                >
                                    {`${product?.c_textNoCTA} ${product?.c_textNoEng}`}
                                </Text>
                            </Box>
                        )}
                    </Box>
                )}
            </Box>
        </Box>
    )
}

DiamondExpertSection.propTypes = {
    product: PropTypes.object
}
export default DiamondExpertSection
